import React, { useState, useEffect } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Col, Row, Input, Form, Button, Typography, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import GradientButton from "../../../components/button/gradientButton";
import './index.css';
import useAuth from "../../../hooks/useAuth";
import logo from "../../../assets/logo.png";

const { Title } = Typography;

const Login = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const { login } = useAuth();
    const [api, contextHolder] = notification.useNotification();

    const [notificationState, setNotificationState] = useState(null);

    useEffect(() => {
        if (notificationState) {
            const { type, message, description } = notificationState;
            api[type]({
                message,
                description,
                placement: "topRight",
            });
            setNotificationState(null);
        }
    }, [notificationState, api]);

    const onSubmit = async (values) => {
        const sanitizedUsername = (values.username || '').toLowerCase().replace(/[^a-z0-9]/g, '');
        try {
            const response = await login(sanitizedUsername, values.password);
            setNotificationState({
                type: "success",
                message: t('SUCCESS'),
                description: t('LOGIN_SUCCESS'),
            });

            navigate("/select-sport");
        } catch (err) {
            setNotificationState({
                type: "error",
                message: t('ERROR'),
                description: err?.response?.data?.message || t('LOGIN_FAILED'),
            });
        }
    };

    const goToForgotPassword = () => {
        navigate("/forgot-password");
    };

    return (
        <>
            {contextHolder}
            <Row style={{ 
                height: "100vh", 
                backgroundColor: "#f7f7f7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <Col xs={24} sm={20} md={16} lg={12} xl={8} style={{ 
                    display: "flex", 
                    flexDirection: "column",
                    alignItems: "center", 
                    justifyContent: "center",
                    padding: "20px"
                }}>
                    {/* Logo */}
                    <div style={{
                        marginBottom: "30px",
                        textAlign: "center"
                    }}>
                        <img 
                            src={logo} 
                            alt="Spor Eğitim Atölyesi Logo" 
                            style={{
                                width: "120px",
                                height: "120px",
                                objectFit: "contain",
                                marginBottom: "20px"
                            }}
                        />
                        <h1 style={{
                            fontSize: "2rem",
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: "10px"
                        }}>
                            Spor Eğitim Atölyesi
                        </h1>
                        <p style={{
                            fontSize: "1rem",
                            color: "#666",
                            margin: 0
                        }}>
                            Öğrenci Takip Sistemi
                        </p>
                    </div>

                    {/* Login Form */}
                    <div style={{ 
                        background: "white", 
                        padding: "40px", 
                        borderRadius: "15px", 
                        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
                        width: "100%",
                        maxWidth: "400px"
                    }}>
                        <Title level={3} className="auth-title" style={{ textAlign: "center" }}>
                            {t('LOGIN')}
                        </Title>
                        <Form
                            name="auth_form"
                            className="auth-form"
                            initialValues={{ remember: true }}
                            onFinish={onSubmit}
                            layout="vertical"
                            form={form}
                        >
                            <Form.Item
                                name="username"
                                label={t('USERNAME')}
                                rules={[
                                    { required: true, message: t('ENTER_USERNAME') },
                                    { pattern: /^[a-z0-9]+$/, message: t('ENTER_USERNAME') }
                                ]}
                            >
                                <Input 
                                    prefix={<UserOutlined />} 
                                    placeholder={t('ENTER_USERNAME')} 
                                    onChange={(e) => {
                                        const v = (e.target.value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
                                        form.setFieldsValue({ username: v });
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                name="password"
                                label={t('PASSWORD')}
                                rules={[
                                    { required: true, message: t('ENTER_PASSWORD') },
                                ]}
                            >
                                <Input.Password
                                    type="password"
                                    prefix={<LockOutlined />}
                                    placeholder={t('PASSWORD')}
                                />
                            </Form.Item>
                            <Form.Item>
                                <GradientButton
                                    type="primary"
                                    htmlType="submit"
                                    size="large"
                                    style={{ width: "100%" }}
                                >
                                    {t('LOGIN')}
                                </GradientButton>
                            </Form.Item>
                        </Form>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default Login;